<script lang="ts">

import PriceToTwoDp from "./PriceToTwoDp.svelte";
import {totalAccessoriesPriceToTwoDecimalPlaces} from "./stores";
</script>
<tr>
    <td class="text-start">Accessories</td>
    <td class="text-end">
        <PriceToTwoDp price={$totalAccessoriesPriceToTwoDecimalPlaces}/>
    </td>
</tr>
